import Vue from 'vue';
import App from './App.vue';
import '../../../public/enrollment.css';

new Vue({ render: h => h(App) }).$mount('#app');
